import {
  ContestAccountType,
  ContestCommonStatus,
  ContestStage,
  ContestType,
} from '../index';
import { BadgeTitle, BadgeTitleEnum } from './contest.enum';
import { UserProgressStatus } from './leaderboard.types';

export const contestMaxParticipants = 100000;

/**
 * @description: User can see contest credentials if contest is active and account has credentials
 * @param contest: ContestType
 * @param account: ContestAccountType
 */
export const userCanSeeContestCredentials = (
  contest: ContestType,
  account: ContestAccountType,
) => Boolean(contest.stage === ContestStage.Active && account?.credentials);

/**
 * @description: User can see leaderboard if it's confirmed by admins
 * @param leaderboardStatus
 * or contest is running and contest.stage equals to 'active'
 * @param contest.leaderboardStatus: ContestCommonStatus
 */
export const userCanSeeLeaderboard = (
  leaderboardStatus: ContestCommonStatus,
) => {
  return [ContestCommonStatus.Confirmed, ContestCommonStatus.None].includes(
    leaderboardStatus,
  );
};

/**
 * Convert UserProgressStatus to BadgeTitleEnum for AvatarWithBadge component
 *
 * @param status - User's progress status from API
 * @returns The corresponding BadgeTitleEnum or null if none
 */
export const convertProgressStatusToBadge = (
  status: UserProgressStatus | undefined | null,
): BadgeTitleEnum | null => {
  if (!status) return null;

  switch (status) {
    case UserProgressStatus.Profitable:
      return BadgeTitle.Profitable;
    case UserProgressStatus.Funded:
      return BadgeTitle.Funded;
    case UserProgressStatus.Verified:
      return BadgeTitle.Verified;
    default:
      return null;
  }
};

export const contestTermsSanitizeOptions = {
  allowedTags: ['p', 'br', 'ul', 'ol', 'li', 'strong', 'em', 'a'],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
  },
};
